  // SVGs
  import obito from '@/assets/icons/flower.svg?sprite'
  import nasc from '@/assets/icons/baby-buggy.svg?sprite'
  import livroE from '@/assets/icons/book-open-variant.svg?sprite'
  import casamento from '@/assets/icons/engagement.svg?sprite'


  export const TiposRegistro = [
    {
      label: 'Nascimento',
      icon: nasc,
      value: 'nascimento',
      id: 3,
    },
    {
      label: 'Casamento',
      icon: casamento,
      value: 'casamento',
      id: 2,
    },
    {
      label: 'Óbito',
      icon: obito,
      value: 'obito',
      id: 1,
    },
    {
      label: 'Livro E',
      icon: livroE,
      value: 'livro-e',
      id: 0,
    }
  ]

  export function obterLabelPorValorRegistro (valor) {
    const registroEncontrado = TiposRegistro.find(registro => registro.value === valor)
    return registroEncontrado ? registroEncontrado.label : null
  }